<template>
    <div class="spinner">
        <div class="bounce1" :style="item_styles"></div>
        <div class="bounce2" :style="item_styles"></div>
        <div class="bounce3" :style="item_styles"></div>
    </div>
</template>

<script>
export default {
    name: 'BounceSpinner',
    props: {
        size: {
            type: Number,
            default: 14,
        },
        color: {
            type: String,
            default: '#ff1572'
        }
    },
    computed: {
        item_styles() {
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
                backgroundColor: this.color
            }
        },
    },
}
</script>

<style scoped>
.spinner {
    margin: 0 auto;
    text-align: center;
}

.spinner > div {
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}

.spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
    }
    40% {
        -webkit-transform: scale(1);
    }
}

@keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    40% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/spinners/BounceSpinner.vue